/* this file copied from react-intl/locale-data/en.js and pared down to
   provide enough functionality for qat usage. */

/* eslint
	"eqeqeq": "off",
	"object-curly-spacing": "off",
	"quotes": "off",
	"no-unused-expressions": "off",
	"semi": "off",
	"yoda": "off",
	"no-nested-ternary": "off",
	"no-var": "off",
	"max-len": "off",
	"id-length": "off",
	"one-var-declaration-per-line": "off",
	"strict": "off",
	"one-var": "off",
	"no-multiple-empty-lines": "off",
	"prefer-arrow-callback": "off",
	"object-shorthand": "off",
	"lines-around-directive": "off",
	"no-undef": "off",
	"wrap-iife": "off"
*/

!(function (e, a) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = a())
    : 'function' == typeof define && define.amd
      ? define(a)
      : ((e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}), (e.ReactIntlLocaleData.en = a()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'qat',
      pluralRuleFunction: function (e, a) {
        var n = String(e).split('.'),
          l = !n[1],
          o = Number(n[0]) == e,
          t = o && n[0].slice(-1),
          r = o && n[0].slice(-2);
        return a
          ? 1 == t && 11 != r
            ? 'one'
            : 2 == t && 12 != r
              ? 'two'
              : 3 == t && 13 != r
                ? 'few'
                : 'other'
          : 1 == e && l
            ? 'one'
            : 'other';
      },
      fields: {
        year: {
          displayName: 'year',
          relative: { 0: 'this year', 1: 'next year', '-1': 'last year' },
          relativeTime: {
            future: { one: 'in {0} year', other: 'in {0} years' },
            past: { one: '{0} year ago', other: '{0} years ago' },
          },
        },
        month: {
          displayName: 'month',
          relative: { 0: 'this month', 1: 'next month', '-1': 'last month' },
          relativeTime: {
            future: { one: 'in {0} month', other: 'in {0} months' },
            past: { one: '{0} month ago', other: '{0} months ago' },
          },
        },
        day: {
          displayName: 'day',
          relative: { 0: 'today', 1: 'tomorrow', '-1': 'yesterday' },
          relativeTime: {
            future: { one: 'in {0} day', other: 'in {0} days' },
            past: { one: '{0} day ago', other: '{0} days ago' },
          },
        },
        hour: {
          displayName: 'hour',
          relative: { 0: 'this hour' },
          relativeTime: {
            future: { one: 'in {0} hour', other: 'in {0} hours' },
            past: { one: '{0} hour ago', other: '{0} hours ago' },
          },
        },
        minute: {
          displayName: 'minute',
          relative: { 0: 'this minute' },
          relativeTime: {
            future: { one: 'in {0} minute', other: 'in {0} minutes' },
            past: { one: '{0} minute ago', other: '{0} minutes ago' },
          },
        },
        second: {
          displayName: 'second',
          relative: { 0: 'now' },
          relativeTime: {
            future: { one: 'in {0} second', other: 'in {0} seconds' },
            past: { one: '{0} second ago', other: '{0} seconds ago' },
          },
        },
      },
    },
  ];
});
